import * as z from "zod";

export const getOptimizedBatchFulfillmentGroupIds = {
  name: "getOptimizedBatchFulfillmentGroupIds" as const,
  input: z.object({ batchSize: z.number().int().positive() }),
  output: z.object({
    groups: z.array(
      z.object({
        id: z.string(),
        filterName: z.string().nullable(),
        labelChargeAmount: z.number(),
      }),
    ),
    totalEligibleOrderCount: z.number(),
  }),
};
